import {useEffect, useState} from 'react';

interface UseModalReturnType {
    visible: boolean;
    message?: string;
    open: (text: string) => void;
    close: () => void;
}

export const useError = (): UseModalReturnType => {
    const [visible, setVisible] = useState(false);
    const [message, setMessage] = useState<string | undefined>(undefined);
    const open = (text: string) => {
        setMessage(text)
    }
    const close = () => {
        setMessage(undefined)
    }

    useEffect(() => {
        setVisible(message !== undefined)
    }, [message])

    return {
        message,
        visible,
        open,
        close,
    };
};
